export const Sorting = {
  ALPHA_DESC: 'alpha-descending',
  ALPHA_ASC: 'alpha-ascending',
} as const;
export type Sorting = typeof Sorting[keyof typeof Sorting];
